module.exports = __webpack_public_path__ + "static/img/LRES_COLOUR_TRANSPARENT_LODRES_cropped.dd814eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LRES_COLOUR_TRANSPARENT_LODRES_cropped.png
// module id = bgAC
// module chunks = 1